import { render } from "./Footer.vue?vue&type=template&id=750897f0"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=750897f0&lang=css"
script.render = render

export default script